import {activity, saveActivity, saveActivityMulti} from "../../api";

export default {
    state: {
        activity: {}
    },
    actions: {
        fetchActivity(context, data) {
            let token = context.getters.getToken.jwt;
            return activity({token, data}).then(r => {
                return context.commit("setActivity", r.data);
            })
        },
        saveActivity(context, data) {
            let token = context.getters.getToken.jwt;
            return saveActivity({token, data});
        },
        saveActivityMulti(context, data) {
            let token = context.getters.getToken.jwt;
            return saveActivityMulti({token, data});
        }
    },
    mutations: {
        setActivity(state, payload) {
            console.log("setActivity payload", payload);
            state.activity = payload;
        }
    }
}